module.exports = __webpack_public_path__ + "img/DK37208779.812dece7.png";